export default "__VITE_ASSET__CtYAH9Fb__"